import React, { useEffect} from "react";
import $ from "jquery";
import "./Report.scss";
import ResultsSpider from "../../components/Spider/ResultsSpider";
import { connect } from "react-redux";
import { gsap } from "gsap";
import ClipboardJS from "clipboard";
import Gate1 from "./../../components/Gate/Gate1";
import Gate from "./../../components/Gate/Gate";

import * as actionCreators from "../../store/actions/index";

import jsonData from "./report.json";
import DynamicAssets from "../../components/DynamicAssets/DynamicAssets";

//animations
let total = 0;
let TotalScore = 0;

let currentLabel = "";
let labelArray = [];

const Report = (props) => {
  const demoHanldr = () => {
    props.onToggleDemo();
  };

  $("html").addClass("show");
  const hostURL = window.location.host;
  const pathURL = window.location.pathname;
  const search = window.location.search;
  const searchURL = window.location.search;
  const params = new URLSearchParams(search);
  let gateOff = params.get("gateoff");
  console.log('gateOff: ' + gateOff)
  let linkedInSearchURL = searchURL.replace(/\b(=)\b/g, (match) => "%3D");
  linkedInSearchURL = linkedInSearchURL.replace(/\b(&)\b/g, (match) => "%26");
  const labelArray = props.currentLabels;

  const showGate = gateOff ? null : <Gate/>;

  let lastLabl = 0;
  let currLabel = 0;

  const ANSWERS_MAP = {
    25: 1,
    50: 2,
    75: 3,
    100: 4,
  };

  useEffect(() => {
    let role = props.rol;
    props.onChooseQuestions(role, "English");
    props.onInitScores(props.scrs);
    function updateSummary() {
      new ClipboardJS(".copy-btn");
      currentLabel = $("dynamic-content-label-0").text();
    }

    for (var i = 0; i < props.scrs.length; i++) {
      const ans_temp = ANSWERS_MAP[props.scrs[i]];
      total += ans_temp;
      TotalScore = Math.round(total);
      if (i === props.scrs.length - 1) {
        setTimeout(function () {
          const obj = document.getElementById("user-score");
          arrangeElements();
          updateSummary();
          cloudAnimations();
          animateNumbers(obj, 0, TotalScore, 1500);
          $(".dynamic-content-text-0").height(
            $(".dynamic-content-text--1-0").height()
          );
        }, 1000);
      }
    }

  }, []);

  window.onresize = arrangeElements;

  function arrangeElements() {
    if (window.innerWidth < 1025) {
      $(".cloud-animation").detach().appendTo(".mobile-cloud-holder");
      $(".report-section-graph").detach().appendTo(".mobile-spider-holder");
      $(".report-section-footer-content")
        .detach()
        .appendTo(".report-section-footer .report__content");
    } else {
      $(".report-section-graph")
        .detach()
        .appendTo(".report-section-spider .report__content-right");
      $(".social-links")
        .detach()
        .appendTo(".report-section-footer .report__content");
      $(".cloud-animation")
        .detach()
        .appendTo(".report-section-hero .report__content-right");
    }
  }
  function confirmCopy() {
    $(".next-step-confirm").addClass("visible");
    setTimeout(function () {
      $(".next-step-confirm").removeClass("visible");
    }, 1000);
  }

  function cloudAnimations() {
    var h = 209;
    if (window.innerWidth < 1024) {
      h = 120.3;
    }
    let backgroundHeight = (TotalScore / 24) * h;
    $("#cloud-anim-background").css("height", (TotalScore / 24) * 100 + "%");
    $("#numbers-holder").css("bottom", backgroundHeight + "px");
  }

  function animateNumbers(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }
  const isGate = () =>{
    if (gateOff === 'true'){
      console.log('isGate if')
      return;
    
    } 
    else{
      console.log('isGate else')
      return  <Gate></Gate>;
    }

  }

  const spiderLabelClickHandlr = (lablName) => {
    lastLabl = currLabel;//
    currLabel = labelArray.indexOf(lablName) + 1;
    /*
    const changeLabel = () => {
     $(".dynamic-content-label-0").text(lablName);
      currentLabel = lablName;
    };
*/
$('.dynamic-content-label').removeClass('active')
$(`.dynamic-content-label-${currLabel}`).addClass('active')
    const checkHeight = () => {
      $(".dynamic-content-text-0").height(
        $(".dynamic-content-text--1-0").height()
      );
    };
    gsap.to(`.dynamic-content-label-${lastLabl}`, {
      x: 10,
      duration: 0.5,
    //  onComplete: changeLabel,
    });

///old
$(`.dynamic-content-text-${lastLabl}`).removeClass('active');
    gsap.to(`.dynamic-content-text-${lastLabl}`, {
      x: 10,
      duration: 0.5,
    });
    gsap.set(`.dynamic-assets-${lastLabl} .btn`, {   attr:{
      "tabindex": '-1'
    }});
    gsap.to(`.dynamic-assets-${lastLabl}`, {
      opacity: 0,
      x: 10,
      duration: 0.5,
    });
///new
$(`.dynamic-content-text-${currLabel}`).addClass('active')
    gsap
      .to(`.dynamic-content-label-${currLabel}`, {
        x: 0,
       // opacity: 1,
        duration: 0.5,
      })
      .delay(0.75);
      gsap.set(`.dynamic-assets-${currLabel} .btn`, {   attr:{
        "tabindex": '6'
      }});
    gsap
      .to(`.dynamic-assets-${currLabel}`, {
        x: 0,
        opacity: 1,
        duration: 0.5,
      })
      .delay(0.75);
   
    gsap
      .to(`.dynamic-content-text-${currLabel}`, {
        x: 0,
        opacity: 1,
        duration: 0.5,
        onStart: checkHeight,
      })
      .delay(0.75);
  };

  const dynamixTxtContentCap = () => {
    const retThis0 = [
      <React.Fragment>
        <div className="dynamix-holder">
        <div
          className={`dynamic-content-label dynamic-content-label-${0} active`}
          key={`d1-${0}`}
        >
        {props.currentLabels[0]}
        </div>
        <div
          className={`dynamic-content-text dynamic-content-text-${0} active`}
          key={`d2-${0}`}
        >
          <p
            className={`dynamic-content-text--1 dynamic-content-text--1-${0}`}
            key={`d3-${0}`}
          >
            {jsonData.capabilitiesx[props.currentLabels[0].toLowerCase()]}
          </p>
          <div className={"dynamic-assets dynamic-assets-0"}>
            <DynamicAssets
              role={props.rol}
              capability={props.currentLabels[0]}
              tabby="6"
            ></DynamicAssets>
          </div>
        </div>
        <div
          className="dynamic-content-hr dynamic-content-hr-0"
          key={`d4-${0}`}
        >
          {" "}
        </div>
        </div>
      </React.Fragment>,
    ];

    const retThis1 = props.currentLabels.map((e, i) => {
      return (
        <React.Fragment>
          <div
            className={`dynamic-content-label dynamic-content-label-${i + 1}`}
            key={`d1-${i + 1}`}
          >
            {props.currentLabels[i]}
          </div>
          <div
            className={`dynamic-content-text dynamic-content-text-${i + 1}`}
            key={`d2-${i + 1}`}
          >
            <p
              className={`dynamic-content-text--1 dynamic-content-text--1-${
                i + 1
              }`}
              key={`d3-${i + 1}`}
            >
              {jsonData.capabilitiesx[props.currentLabels[i].toLowerCase()]}
            </p>
            <div className={`dynamic-assets dynamic-assets-${i + 1}`} >
              <DynamicAssets
                role={props.rol}
                capability={props.currentLabels[i]}
                tabby="-1"
              ></DynamicAssets>
            </div>
          </div>
          <div
            className={`dynamic-content-hr dynamic-content-hr-${i + 1}`}
            key={`d4-${i + 1}`}
          >
            {" "}
          </div>
        </React.Fragment>
      );
    });

    return retThis0.concat(retThis1);
  };

  return (
    <div className="report">
               {isGate()}
      <section className="report-section report-section-hero">
        <div className="report__content ">
          <div className="report__content-left">
            <div className="report-section-hero-logo"></div>
            <h3>RESULTS REPORT</h3>
            <hr className="Landing__hr"></hr>
            <h1 className="Landing__title">
              HR analytics
              self-assessment
            </h1>
            <div className="mobile-cloud-holder"></div>
            <div id="executive-summary">
              Based on your survey responses, your company appears to be on the
              way to achieving analytics mastery. As you progress, your company
              should continue to adopt an analytics-driven culture. Below are
              some resources for you to use as you continue your HR analytics
              path. Take a{" "}
              <a
                href="https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-hcm/index.html"
                target="_blank"
                tabindex='1'
              >
                product tour
              </a>
              , request a{" "}
              <a
                href="https://www.oracle.com/elq-demo-form.html?qt=saas_hcm_fam"
                target="_blank"
                tabindex='2'
              >
                demo
              </a>
              , or visit the <a href="https://www.oracle.com/business-analytics/fusion-hcm-analytics/"
                target="_blank"
                tabindex='3'>
               Oracle Fusion Analytics for HCM 
                </a> page for additional details on
              how to improve your abilities to recruit, retain, and forecast
              talent needs.
            </div>
          </div>
          <div className="report__content-right relative">
            <div className="cloud-animation">
              <div className="cloud-animation-numbers" id="numbers-holder">
                <div className="cloud-animation-number" id="user-score"></div>
                <div className="cloud-animation-number">/24</div>
              </div>
              <div
                className="cloud-animation-image-2"
                id="cloud-anim-background"
              ></div>
              <div className="cloud-animation-image-1"></div>
              <div className="cloud-animation-label">
                Overall HR Analytics Score
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="report-section report-section-spider">
        <div className="report__content">
          <div className="report__content-left">
            <div className="report-section-header">
              Capabilities and resources
            </div>

            <div className="mobile-spider-holder"></div>
            <div className="dynamic-content">{dynamixTxtContentCap()}</div>
          </div>
          <div className="report__content-right">
            <div className="report-section-graph">
              <ResultsSpider
                spdrlblclick={spiderLabelClickHandlr}
                labelArray={props.currentLabels}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="report-section report-section-summary">
        <div className="report__content">
          <div className="report__content-left">
            <div className="report-section-header">Next steps</div>
            <div className="report-section-summary-content">
              <p>
   Moving to an analytics-driven approach centered on your people is an essential step towards HR analytics mastery.  HR professionals need ready-to-use workforce insights to improve their decisions related to workforce diversity, employee attrition and retention, talent acquisition, compensation, and more. Oracle’s unique breadth and depth of prebuilt analytics, cross-departmental and extensibility capabilities enable organizations to unify human resource analytics across different departments.
              </p>
              <p>
                For information on Analytics for Human Resources visit:{" "}
                <a
                  href="https://www.oracle.com/business-analytics/fusion-hcm-analytics/"
                  target="_blank"
                >
                  https://www.oracle.com/business-analytics/fusion-hcm-analytics/
                </a>
              </p>
              <p className="relative">
                <button
                 className="next-step-btn copy-btn"
                 data-clipboard-action="copy"
                 data-clipboard-text={window.location+`&gateoff=true`}
                 onClick={confirmCopy}
                 tabindex="9"
                >
                 Copy report link
                </button>
                <div className="next-step-confirm">Link copied!</div>

              </p>
            </div>
          </div>
          <div className="report__content-right">
            <div className="next-steps">
              <div className="next-step next-step-left">
                <div className="next-step-icon next-step-icon-demo"></div>
                <div className="next-step-label">Request a Demo</div>
                <div className="next-step-text cheat-wide"> Take a walkthrough with one of our experts.</div>
                <a
                  className="next-step-btn"
                  href="https://www.oracle.com/elq-demo-form.html?qt=saas_hcm_fam"
                  target="_blank"
                  tabindex="7"
                >
                  Request a demo
                </a>
              </div>

              <div className="next-step next-step-top ">
                <div className="next-step-icon next-step-icon-tour"></div>
                <div className="next-step-label">Take a Tour</div>
                <div className="next-step-text">Explore Oracle Fusion HCM Analytics on your own.</div>
                <a
                  className="next-step-btn"
                  href="https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-hcm/index.html"
                  target="_blank"
                  tabindex="8"
                >
                  Browse tours
                </a>
              </div>

              <div className="next-step next-step-left">
                <div className="next-step-icon next-step-icon-video"></div>
                <div className="next-step-label">Explore videos</div>
                <div className="next-step-text">Keep abreast of the latest use-cases and demo videos.</div>
                <a
                  className="next-step-btn"
                  href="https://www.youtube.com/playlist?list=PL6gBNP-Fr8KUaE-w5vXBTyrTOoOL0xqZK"
                  tabindex="9"
                  target="_blank"
                >
                  Watch videos
                </a>
              </div>

              <div className="next-step">
                <div className="next-step-icon next-step-icon-contact"></div>
                <div className="next-step-label">Follow us</div>
                <div className="next-step-text cheat-wide">Get the latest Oracle Analytics news, events, and community resources.</div>
                <a
                  className="next-step-btn"
                  href="https://twitter.com/OracleAnalytics"
                  target="_blank"
                  tabindex="10"
                >
                  Follow us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="report-section report-section-footer">
        <div className="report__content">
          <div className="report-section-footer-content">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.oracle.com/legal/privacy/"
              className="report-section-footer-link"
            >
              © 2022 Oracle
            </a>

            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.oracle.com/legal/privacy/"
              className="report-section-footer-link"
            >
              Privacy/Do Not Sell My Info
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              id="teconsent"
              className="report-section-footer-link"
            ></a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.oracle.com/legal/privacy/privacy-policy.html#advertising"
              className="report-section-footer-link last-link"
            >
              Ad Choices
            </a>
          </div>
          <div className="social-links">
            <div className="Socials__text">Share:</div>
            <a
              rel="noreferrer"
              href={`https://www.linkedin.com/shareArticle?mini=true&url=https://${hostURL}${pathURL}`}
              className="Socials__icon Socials__icon--4"
              target="_blank"
            ></a>
            <a
              rel="noreferrer"
              href={`https://twitter.com/intent/tweet?url=https://${hostURL}${pathURL}&text=Use%20this%20tool%20to%20score%20your%20organization%E2%80%99s%20people%20analytic%20strategy%20and%20learn%20how%20to%20improve%20your%20use%20of%20HR%20Data.`}
              className="Socials__icon Socials__icon--3"
              target="_blank"
            ></a>
            <a
              rel="noreferrer"
              href={`https://www.facebook.com/sharer/sharer.php?u=https://${hostURL}${pathURL}`}
              target="_blank"
              className="Socials__icon Socials__icon--2"
            ></a>
          </div>
          <div className="o-tag"></div>
        </div>
      </section>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChooseQuestions: (role, lang) =>
      dispatch(actionCreators.choose_questions(role, lang)),
    onInitScores: (scrz) => dispatch(actionCreators.init_scores(scrz)),
    onToggleDemo: () => dispatch(actionCreators.toggle_demo()),
  };
};

const mapStateToProps = (state) => {
  return {
    currentLabels: state.questionsReducer.currentLabels,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Report);
